export default {
  title: {
    list: 'Comments',
    list_working: 'Projects',
    edit: 'Update my rating',
    create: 'Rate the route',
  },
  table: {
    author: 'climber',
    grade: 'grade',
    tickType: 'ticking',
    liked: 'like',
    message: 'message',
    variant: 'variant',
    createdAt: 'date',
  },
  form: {
    tickType: 'Ticking',
    message: 'Comment',
    grade: 'Grade',
    liked: 'Like',
    variants: 'Variant',
    submit: 'Publish',
    authorAnonymous: 'Climber',
  },
  tooltip: {
    tickTypes: {
      working: 'project',
      redpoint: 'red point',
      flash: 'flash',
      onsight: 'onsight',
    },
  },
  helper: {
    cta_anonymous: {
      title: 'You are not connected',
      body: 'For a better experience, log in to register and track your ticks.',
    },
    no_comments: 'Be the first to rate this route',
    anonymous: 'Anonymous',
    consent:
      'By publishing a comment, you accept the <tou>Terms and Conditions</tou> ' +
      'and the VerticalTopo\'s <pp>Privacy Policy</pp>.',
  },
  log: {
    types: {
      'route-created': 'Route created',
      'route-modified': 'Route modified',
      'route-archived': 'Route archived',
    },
  },
  delete: {
    button: 'Delete my rating',
    confirm: {
      title: 'Confirm the deletion of the rating',
      submit: 'Delete',
    },
  },
  menu: {
    edit: 'edit',
    delete: 'delete',
  },
}
